import React from 'react';
export const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="w-full py-10 sm:py-12 border-t border-white/10 bg-black" data-id="element-41">
      <div className="max-w-6xl mx-auto px-4" data-id="element-42">
        <div className="grid grid-cols-2 sm:flex sm:flex-row justify-between items-start gap-8" data-id="element-43">
          <div className="flex flex-col items-start col-span-2 mb-6 sm:mb-0" data-id="element-44">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b2kw2oJmb8JUi9aYWVqUFj/pasted-image.png" alt="SVRN PRO Logo" className="h-10 mb-4" data-id="element-45" />
            <p className="text-white/70 text-sm sm:text-base" data-id="element-46">
              High-performance sales team
              <br data-id="element-47" />
              providing homeowners energy solutions
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-48">
            <h3 className="text-white font-medium mb-3 text-sm sm:text-base" data-id="element-49">
              Navigate
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-50">
              <li data-id="element-51">
                <button onClick={() => scrollToSection('headline')} className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-52">
                  Our Promise
                </button>
              </li>
              <li data-id="element-53"></li>
              <li data-id="element-54">
                <button onClick={() => scrollToSection('faq')} className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-55">
                  FAQ
                </button>
              </li>
            </ul>
          </div>
          <div className="flex flex-col items-start" data-id="element-56">
            <h3 className="text-white font-medium mb-3 text-sm sm:text-base" data-id="element-57">
              Legal
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-58">
              <li data-id="element-59">
                <a href="https://svrnpro.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-60">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-61">
                <a href="https://svrnpro.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-62">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 sm:mt-10 pt-4 sm:pt-6 border-t border-white/10 text-center" data-id="element-63">
          <p className="text-white/50 text-xs sm:text-sm" data-id="element-64">
            © {new Date().getFullYear()} SVRN PRO. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};